import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  DeleteButton,
  NumberField,
} from 'react-admin';

export const CharacteristicGroupList = () => (
  <List>
    <Datagrid>
      <TextField source="name" />
      <TextField source="slug" />
      <NumberField source="sortOrder" />
      <DateField source="createdAt" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
